var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getLots && _vm.getLots.length)?_c('div',{staticClass:"su-lots-info"},[_c('div',{staticClass:"cards-list c-company__list js-masonry"},_vm._l((_vm.getLots),function(lot,idx){return _c('Card',{key:idx,attrs:{"lot":lot}})}),1)]):_c('div',{staticClass:"su-empty su-about-empty"},[_c('EmptyBlock')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }